/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, July 2020
 */

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FlowBlockTos as BlockModel } from '@staffino/model';
import { TosBlock as Component } from '@staffino/flow-controls';
import useBridge from '../use-bridge-hook';
import DocumentViewerModal from '../controls/document-viewer-modal';
import useObjects from '../use-objects-hook';

type Props = {
  block: BlockModel;
  color?: string;
};
const TosBlock = ({ block, color }: Props) => {
  const bridge = useBridge();
  const [documentIndex, setDocumentIndex] = useState(undefined);
  const { t } = useTranslation();
  const [locale] = useObjects('locale', { id: bridge.localeId });
  const [flow] = useObjects('flow');
  const supportedLocale = ['sk', 'pl', 'tr', 'it', 'de'].includes(locale?.code)
    ? locale.code
    : 'en';
  const privacyPolicyUrl =
    flow?.privacyPolicyUrl === '' ? false : flow?.privacyPolicyUrl;
  const documents = [];
  if (privacyPolicyUrl !== false) {
    documents.push({
      title: t('Privacy Policy'),
      url:
        privacyPolicyUrl ||
        `https://s3-eu-west-1.amazonaws.com/cdn-static.staffino.com/documents/web/privacy-policy.${supportedLocale}.html`,
    });
  }
  return (
    <>
      {documentIndex !== undefined && (
        <DocumentViewerModal
          documents={documents}
          activeIndex={documentIndex}
          onChange={setDocumentIndex}
        />
      )}
      <Component
        block={{ ...block, privacyPolicyUrl }}
        color={color}
        onSelect={setDocumentIndex}
      />
    </>
  );
};

export default TosBlock;
